// Audit log: who did what from the console (and the desk), last 14 days; one login or all.
// The API has written audit/ entries all along; GET /audit is newer, so a 404 says so.

import React, { useEffect, useState } from 'react';
import {
    Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody,
    TableCell, TableRow, Typography,
} from '@mui/material';
import { getAudit, notThere } from './api';
import { fmtTime } from './deskModel';
import { useTones } from './tones';

const DETAIL_KEYS = ['reason', 'job_types', 'job_type', 'scratch', 'run_id', 'mode', 'desk'];
const detailText = (e) => DETAIL_KEYS.filter((k) => e[k] !== undefined && e[k] !== null && e[k] !== '')
    .map((k) => (k === 'scratch' ? (e[k] ? 'test' : 'live') : Array.isArray(e[k]) ? e[k].join(', ') || 'all jobs' : String(e[k])))
    .join(' · ');

// target: { login: id | null } or null.
const AuditDialog = ({ target, onClose }) => {
    const { muted } = useTones();
    const [entries, setEntries] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!target) return;
        setEntries(null); setError(null);
        getAudit(target.login, 14)
            .then((d) => setEntries((Array.isArray(d) ? d : d?.entries || d?.audit || []).slice().sort((a, b) => (a.at < b.at ? 1 : -1))))
            .catch((e) => setError(notThere(e) ? 'The audit log view needs the newer Browser Desk API, which is not deployed yet.' : e.message));
    }, [target]);
    return (
        <Dialog open={Boolean(target)} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle className="d-font">
                Audit log{target?.login ? ` — ${target.login}` : ''}
                <Typography className="d-font" sx={{ fontSize: 12, color: muted }}>Last 14 days</Typography>
            </DialogTitle>
            <DialogContent>
                {error && <Alert severity="info">{error}</Alert>}
                {!error && !entries && <CircularProgress size={24} />}
                {entries && !entries.length && <Typography className="d-font" sx={{ fontSize: 13, color: muted }}>Nothing recorded.</Typography>}
                {entries && entries.length > 0 && (
                    <Box sx={{ overflowX: 'auto' }}>
                        <Table size="small">
                            <TableBody>
                                {entries.map((e, i) => (
                                    <TableRow key={`${e.at}-${i}`}>
                                        <TableCell className="d-font" sx={{ fontSize: 12, whiteSpace: 'nowrap' }}>{fmtTime(e.at)}</TableCell>
                                        <TableCell className="d-font" sx={{ fontSize: 12, fontWeight: 600 }}>{e.action}</TableCell>
                                        <TableCell className="d-font" sx={{ fontSize: 12 }}>
                                            {[e.by, target?.login ? null : e.credential, detailText(e)].filter(Boolean).join(' · ')}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                )}
            </DialogContent>
            <DialogActions sx={{ '& .MuiButton-root': { textTransform: 'none' } }}><Button onClick={onClose}>Close</Button></DialogActions>
        </Dialog>
    );
};

export default AuditDialog;
